import { Badge } from '@any-ui-react/core';

import { ProbationReviewCompletionMethod, ProbationReviewReviewStatus } from '@/common/graphql';
import { ProbationReviewReviewStatusLabels } from '@/common/types';

interface Props {
  status: ProbationReviewReviewStatus;
  completionMethod: ProbationReviewCompletionMethod | null;
}

const completionMethodLabel: Record<ProbationReviewCompletionMethod, string> = {
  [ProbationReviewCompletionMethod.SubmittedInMed]: '',
  [ProbationReviewCompletionMethod.CompletedOffline]: 'offline',
  [ProbationReviewCompletionMethod.LegacyRecord]: 'legacy record',
};

/** The state of one review: Draft, Submitted, or Completed with how it was completed (the dates are shown elsewhere). */
export const ReviewStageStatusBadge = ({ status, completionMethod }: Props) => {
  if (status === ProbationReviewReviewStatus.Draft) {
    return <Badge color="gray">{ProbationReviewReviewStatusLabels[status]}</Badge>;
  }

  if (status === ProbationReviewReviewStatus.Submitted) {
    return <Badge color="green">{ProbationReviewReviewStatusLabels[status]}</Badge>;
  }

  const method = completionMethod ? completionMethodLabel[completionMethod] : '';

  return (
    <Badge color="blue">
      {method ? `${ProbationReviewReviewStatusLabels[status]} (${method})` : ProbationReviewReviewStatusLabels[status]}
    </Badge>
  );
};
